import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=8522b0ea&scoped=true"
import script from "./AppDetail.vue?vue&type=script&lang=js"
export * from "./AppDetail.vue?vue&type=script&lang=js"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=8522b0ea&prod&scoped=true&lang=css"
import style1 from "./AppDetail.vue?vue&type=style&index=1&id=8522b0ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8522b0ea",
  null
  
)

export default component.exports